import { useContext } from "react";
import UserContext from "./UserContext";

const useUsers = () => {
    return useContext(UserContext);
}

export default useUsers;